import { IconChevronRight } from '@lib/icons'
import { Button } from '@octopus-do/octopus-storybook'
import { ArrowLeft } from '@octopus-do/octopus-storybook/icons'
import { openModal } from '@storeOld/reducers/ui'
import cx from 'classnames'
import type React from 'react'
import { useDispatch } from 'react-redux'

import type { ModalProps } from '@/types/modal'
import { IMPORT_PROJECT } from '../../../../../constants'
import css from '../../../../Import.module.scss'
import { actionUrls } from '../../../TextWithAction'
import CrawlerStatusLogo from './CrawlerStatusLogo'

type Props = ModalProps & {
  error: string
}

const CrawlerError: React.FC<Props> = ({ error, closeButton }) => {
  const dispatch = useDispatch()

  return (
    <div className={css.container}>
      <div className={css.heading}>
        <div className={css.close}>{closeButton}</div>
      </div>

      <div className={css.content}>
        <div className={css.loadingWrapper}>
          <CrawlerStatusLogo status="failed" />

          <div className={css.crawlingTitle}>Crawl failed</div>

          <p className={cx(css.description, css.error)}>{error}</p>
          <a
            target="_blank"
            href={actionUrls.CRAWLER_ERRORS_DESCRIPTIONS}
            className={cx(css.link, css.linkButton)}
            rel="noopener"
          >
            More in Help center
            <IconChevronRight />
          </a>

          <Button
            className={css.errorButton}
            priority="secondary"
            label="Back"
            left={ArrowLeft}
            onClick={() => {
              dispatch(openModal(IMPORT_PROJECT))
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default CrawlerError
